import type { MapAccommodationTileDesktopProps } from '@/features/map/map-components/map-tiles/accommodation-tiles/accommodation-desktop/map-accommodation-tile-desktop';

import React from 'react';

import BadgeDesktop from '@/core/components/badges/badge-desktop/badge-desktop';
import Badges from '@/core/components/badges/badges';
import { KeyFactsHorizontal } from '@/core/features';
import AccommodationTileRating from '@/features/accommodation-tiles/accommodation-tiles-v1/accommodation-tile/accommodation-tile-rating';
import AccommodationTileStarsDesktop from '@/features/accommodation-tiles/accommodation-tiles-v1-desktop/accommodation-tile-desktop/accommodation-tile-stars-desktop';

type MapAccommodationTileContentProps = Pick<
    MapAccommodationTileDesktopProps,
    'accommodationTypeBadge' | 'badges' | 'highlightedBadges' | 'keyfacts' | 'name' | 'rating' | 'stars'
> & { hasSelectedVertical?: boolean; toggleTileOpen: () => void };

export function MapAccommodationTileContent({
    accommodationTypeBadge,
    badges,
    hasSelectedVertical,
    highlightedBadges,
    keyfacts,
    name,
    rating,
    stars,
    toggleTileOpen,
}: MapAccommodationTileContentProps) {
    const hasRating = !!rating.countText;

    return (
        <div
            className={`${highlightedBadges.length > 0 ? 'bg-foam' : ''} flex flex-col justify-between gap-10 p-10 h-full ${!hasSelectedVertical ? 'pointer' : ''}`}
            onClick={toggleTileOpen}
        >
            <div className={'flex flex-col gap-10 mb-10'}>
                <div className={'flex flex-col'}>
                    {accommodationTypeBadge && (
                        <div className={'flex justify-start items-start'}>
                            <BadgeDesktop
                                badge={accommodationTypeBadge}
                                padding={'p-0'}
                            />
                        </div>
                    )}
                    <div className={'ellipsis mb-5 text-16 font-bold'}>{name}</div>
                    {stars && stars.count > 0 && (
                        <AccommodationTileStarsDesktop
                            accommodationStars={stars}
                            size={14}
                            tooltipText={stars?.htmlOverlayText}
                        />
                    )}
                </div>
                {hasRating && (
                    <AccommodationTileRating
                        rating={rating}
                        size={32}
                    />
                )}
                {keyfacts.length > 0 && (
                    <div className={'flex flex-wrap justify-start items-center gap-3 mb-10'}>
                        <KeyFactsHorizontal
                            bulletSpacing={'pl-10 pr-10'}
                            fontSize={'text-12'}
                            keyfacts={keyfacts}
                            lineClamp={'line-clamp-2'}
                            lineHeight={'leading-16'}
                        />
                    </div>
                )}
            </div>
            <Badges
                badges={badges}
                wrap={'wrap'}
            />
        </div>
    );
}
